import React, { createContext, useContext, useState, useMemo } from "react";

const translations = {
  it: {
    brand: "WordCripto",
    tagline: "Simulatore d'investimento a 10 anni",
    nav_sim: "Simulatore",
    nav_help: "Istruzioni",
    nav_company: "Azienda",
    sim_title: "Simulazione 120 mesi",
    sim_subtitle: "0,17% al giorno · vincolo 12 mesi · reinvesto automatico oltre $500",
    start_date: "Data d'inizio",
    year: "Anno",
    month: "Mese",
    reset: "Ripristina",
    recalculate: "Ricalcola",
    col_month: "Mese",
    col_deposit: "Versamento",
    col_capital_start: "Capitale inizio",
    col_liq_start: "Liquidità inizio",
    col_profit: "Guadagno del mese",
    col_withdrawal: "Ritiro",
    col_reinvested: "Reinvestito",
    col_liq_end: "Liquidità fine",
    col_capital_end: "Capitale fine",
    tot_deposited: "Totale versato",
    tot_withdrawn: "Totale ritirato",
    tot_reinvested: "Totale reinvestito",
    final_capital: "Capitale finale",
    final_liquidity: "Liquidità finale",
    final_total: "Totale finale",
    growth: "Crescita netta",
    withdrawal_mode: "Modalità",
    mode_spot: "Spot",
    mode_continuous: "Continuo",
    mode_none: "Nessuno",
    withdrawal_type_usd: "USD",
    withdrawal_type_pct: "% guadagno",
    warn_capital: "Attenzione: ritiro superiore al guadagno — il capitale diminuisce",
    min_deposit_hint: "Minimo $500 per versamento",
    company_title: "Chi siamo",
    help_title: "Come si usa",
    lang_it: "IT",
    lang_en: "EN",
    input_deposit_ph: "es. 1000",
    input_wd_ph: "es. 500",
    quick_start_title: "Inizio rapido",
    quick_start_note: "Inserisci un versamento iniziale al mese 1 e scegli eventuali ritiri. Il resto è automatico.",
    initial_deposit: "Versamento iniziale (mese 1)",
    footer_disclaimer: "Simulazione a scopo illustrativo. I risultati passati non garantiscono rendimenti futuri.",
    chart_title: "Andamento del portafoglio",
    chart_subtitle: "Capitale, liquidità e totale mese per mese",
    export_pdf: "Esporta PDF",
    share_link: "Copia link",
    link_copied: "Link copiato negli appunti",
    nav_compare: "Confronta",
    compare_title: "Confronto scenari",
    compare_subtitle: "Metti due strategie fianco a fianco e vedi subito quale conviene",
    scenario_a: "Scenario A",
    scenario_b: "Scenario B",
    monthly_deposit: "Versamento mensile",
    monthly_withdrawal: "Ritiro mensile (USD)",
    initial_deposit_lbl: "Versamento iniziale",
    diff_label: "Differenza finale",
    winner: "Vincitore",
  },
  en: {
    brand: "WordCripto",
    tagline: "10-year investment simulator",
    nav_sim: "Simulator",
    nav_help: "How-to",
    nav_company: "Company",
    sim_title: "120-month projection",
    sim_subtitle: "0.17% daily · 12-month lock · auto-reinvest above $500",
    start_date: "Start date",
    year: "Year",
    month: "Month",
    reset: "Reset",
    recalculate: "Recalculate",
    col_month: "Month",
    col_deposit: "Deposit",
    col_capital_start: "Capital start",
    col_liq_start: "Cash start",
    col_profit: "Month profit",
    col_withdrawal: "Withdrawal",
    col_reinvested: "Reinvested",
    col_liq_end: "Cash end",
    col_capital_end: "Capital end",
    tot_deposited: "Total deposited",
    tot_withdrawn: "Total withdrawn",
    tot_reinvested: "Total reinvested",
    final_capital: "Final capital",
    final_liquidity: "Final cash",
    final_total: "Final total",
    growth: "Net growth",
    withdrawal_mode: "Mode",
    mode_spot: "Spot",
    mode_continuous: "Recurring",
    mode_none: "None",
    withdrawal_type_usd: "USD",
    withdrawal_type_pct: "% of profit",
    warn_capital: "Warning: withdrawal exceeds profit — capital is reduced",
    min_deposit_hint: "Minimum $500 per deposit",
    company_title: "About us",
    help_title: "How to use",
    lang_it: "IT",
    lang_en: "EN",
    input_deposit_ph: "e.g. 1000",
    input_wd_ph: "e.g. 500",
    quick_start_title: "Quick start",
    quick_start_note: "Enter an initial deposit at month 1 and optionally schedule withdrawals. The rest is automatic.",
    initial_deposit: "Initial deposit (month 1)",
    footer_disclaimer: "Illustrative simulation. Past results do not guarantee future returns.",
    chart_title: "Portfolio growth",
    chart_subtitle: "Capital, cash and total, month by month",
    export_pdf: "Export PDF",
    share_link: "Copy link",
    link_copied: "Link copied to clipboard",
    nav_compare: "Compare",
    compare_title: "Scenario comparison",
    compare_subtitle: "Put two strategies side by side and see immediately which one wins",
    scenario_a: "Scenario A",
    scenario_b: "Scenario B",
    monthly_deposit: "Monthly deposit",
    monthly_withdrawal: "Monthly withdrawal (USD)",
    initial_deposit_lbl: "Initial deposit",
    diff_label: "Final difference",
    winner: "Winner",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState("it");
  const value = useMemo(() => ({
    lang,
    setLang,
    t: (k) => translations[lang][k] ?? k,
  }), [lang]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be inside I18nProvider");
  return ctx;
}
